import React, { useEffect, useState } from "react";
import Button from "../../extras/Button";
import { ExInput } from "../../extras/Input";
import { useDispatch, useSelector } from "react-redux";
import { closeDialog } from "../../../redux/slice/dialogueSlice";
import { cancelBooking } from "../../../redux/slice/bookingSlice";
import { permissionError } from "../../../util/Alert";
import { Box, Modal } from "@mui/material";

const CancelBookingDialog = () => {
  const { dialogueData } = useSelector((state) => state.dialogue);
  const hasPermission = useSelector((state) => state.auth.admin.flag)
  const dispatch = useDispatch();
  const [reason, setReason] = useState("");
  const [mongoId, setMongoId] = useState("");
  const [error, setError] = useState("");


  useEffect(() => {
    if (dialogueData) {
      setMongoId(dialogueData);
    }
  }, [dialogueData]);

  const handleSubmit = async (e) => {
    if (!hasPermission) return permissionError();
    e.preventDefault();
    if (!reason) {
      setError("Reason is Required");
    } else {
      if (dialogueData) {
        const payload = {
          reason: reason,
          person: "admin",
          bookingId: mongoId,
          status: "cancel",
        };
        dispatch(cancelBooking(payload));
        dispatch(closeDialog());
      }
    }
  };

  return (
    <Modal
      open={true}
      onClose={closeDialog}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box className="model-style">
        <div className="model-header">
          <p className="m-0">Cancel Booking</p>
        </div>
        <div className="model-body">
          <form id="expertForm">
            <div className="row align-items-start formBody">
              <div className="col-12">
                <ExInput
                  type={`text`}
                  id={`reason`}
                  name={`reason`}
                  label={`Reason`}
                  placeholder={`Reason`}
                  value={reason}
                  onChange={(e) => {
                    setReason(e.target.value);
                    if (!e.target.value) {
                      return setError("Reason is Required !");
                    } else {
                      setError("");
                    }
                  }}
                />
                {error && (
                  <p className="errorMessage text-start">
                    {error && error}
                  </p>
                )}
              </div>
            </div>

          </form>
        </div>
        <div className="model-footer">
          <div className="m-3 d-flex justify-content-end gap-2">
            <Button
              className={`close-model-btn`}
              text={`Cancel`}
              type={`button`}
              onClick={() => dispatch(closeDialog())}
            />
            <Button
              type={`submit`}
              text={`Submit`}
              onClick={(e) => handleSubmit(e)}
            />

          </div>
        </div>
      </Box>

    </Modal>
  );
};
export default CancelBookingDialog;
